import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'

import { registerLocale } from 'react-datepicker'
import it from 'date-fns/locale/it'
import en from 'date-fns/locale/en-US'

/**
 * Componente per gestire la provincia
 * EE -> se il paese è straniero
 * se è italiano la provincia deve essere di massimo 2 caratteri
 *
 * @param {String} name - Il nome del campo di input
 * @param {String} placeholder - Il placeholder del campo di input
 * @param {String} value - Il valore del campo di input
 * @param {Function} onChange - L'handler dell'evento onChange del campo di input
 * @param {Function} onFocus - L'handler dell'evento onFocus del campo di input
 * @param {Object} error - L'oggetto di errore del campo di input
 * @param {Boolean} disabled - Lo stato di disabilitazione del campo di input
 */
export function ProvinceField(props) {
  const [error, setError] = useState({ isValid: true, msg: '' })
  const lang = useSelector((state) => state.language.language)

  registerLocale(lang, lang === 'it' ? it : en)

  useEffect(() => {
    // Serve per settare gli errori
    if (props.error !== undefined && props.error !== error) {
      setError(props.error)
    } else {
      setError({ isValid: true, msg: '' })
    }
  }, [props.error])

  return (
    <>
      <div className="form-group">
        <div className="input-group col-6 ps-0">
          <input
            type={'text'}
            className={'form-control'}
            name={props.name}
            onFocus={props.onFocus}
            onChange={props.onChange}
            value={props.province}
            disabled={props.disabled}
            placeholder={props.placeholder}
          />
        </div>
        {!error.isValid ? <div className="text-danger">{error.msg}</div> : ''}
      </div>
    </>
  )
}
